import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import { userMixin } from './mixins/user.mixin';
import { utilityMixin } from './mixins/utility.mixin';
import {
  date,
  hour,
  capitalize,
  datetime,
  phone,
  upper,
  empty,
} from './filters';
import ToggleButton from 'vue-js-toggle-button';
import { i18n } from './i18n';
import vuetify from '@/plugins/vuetify' // path to vuetify export
import TawkMessengerVue from '@tawk.to/tawk-messenger-vue-2';

import 'bootstrap/dist/js/bootstrap.min.js';

//disable production tip
Vue.config.productionTip = false;

//filters
Vue.filter('date', date);
Vue.filter('hour', hour);
Vue.filter('capitalize', capitalize);
Vue.filter('datetime', datetime);
Vue.filter('phone', phone);
Vue.filter('upper', upper);
Vue.filter('empty', empty);

//core
import './core/vue/error-handler';

//plugins
import './plugins/vee-validate.plugin';
import './plugins/bootstrap-vue.plugin.js';

//mixins
Vue.mixin(userMixin);
Vue.mixin(utilityMixin);

//styles
import '@/scss/main.scss';
import '@/assets/css/all.css';
import '@/assets/css/solid.css';
import '@/assets/css/style.css';
import "vuetify/dist/vuetify.min.css";

//TODO: Change for enviroment variables : VUE_APP_TAWK_PROPERTY_ID, VUE_APP_TAWK_WIDGET_ID

Vue.use(TawkMessengerVue, {
  propertyId: process.env.VUE_APP_TAWK_PROPERTY_ID,
  widgetId: process.env.VUE_APP_TAWK_WIDGET_ID,
});
//plugins
Vue.use(ToggleButton);

new Vue({
  router,
  store,
  i18n,
  vuetify,
  render: (h) => h(App),
}).$mount('#app');
